import React from "react";
import "./SessionExpiredPopup.css";

const SessionExpiredPopup = ({ onClose }) => {
  return (
    <div className="session-expired-overlay">
      <div className="session-expired-modal">
        <div className="session-expired-header">
          <h2>You have been signed out</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="session-expired-content">
          <p>You've been signed out of the application. Please signin again to Continue.</p>
        </div>
        <div className="session-expired-footer">
          <button className="sign-in-again-button" onClick={onClose}>
            Sign in again
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredPopup;